/*
 * Copyright (c) to Energy Analytics & Solutions Pty Ltd. All rights reserved.
 */

import React from 'react'
 import servicesStripImg from '../../assets/Images/02.jpg'
const Whereweput = () => {
    return (
        <>

            <section className='mt-4 mb-4'>
                <div className='container'>
                    <div className='row'>
                        <h1 className='text-center' style={{ color: "#2e3192" }}>WHERE WE PUT OUR ENERGIES</h1>
                        <div className='col-sm-6'>
                            <div className='px-4'>
                                <p>Many businesses don’t really question or understand their energy consumption, and even fewer know how to reduce their carbon footprint and get to net zero. </p>
                                <p>Matters are not helped by the fact that most businesses receive a monthly bill that only tells them their overall usage and how much they have to pay.</p>
                            </div>
                        </div>
                        <div className='col-sm-6'>
                            <div className='px-4'>
                                <p>Unfortunately, this doesn’t provide them with insights as to where and how their energy is being used, if there is any wastage or if their machinery is inefficient. </p>
                                <p>Because of this, businesses (and users) are often in the dark (literally if they don’t pay the bill) when trying to become efficient and in control of their usage. </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='mt-4 mb-5 servicesStrip-cst-img'>
                <div className='container'>
                    <h3 className="w-50 text-white text-start custom-business-gain">
                        AND THAT’S WHERE EA&S COMES IN. WE HELP BUSINESSES GAIN CONTROL OF THEIR USAGE AND EXPENDITURE AND MOVE EVER CLOSER TOWARDS NET ZERO.
                    </h3>
                </div>

            </section>
        </>
    )
}

export default Whereweput

/*
 * Copyright (c) to Energy Analytics & Solutions Pty Ltd. All rights reserved.
 */